export default "__VITE_ASSET__9bL6QYCB__"